import { render, staticRenderFns } from "./msWelfare.vue?vue&type=template&id=6d302909&scoped=true"
import script from "./msWelfare.vue?vue&type=script&lang=js"
export * from "./msWelfare.vue?vue&type=script&lang=js"
import style0 from "./msWelfare.vue?vue&type=style&index=0&id=6d302909&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d302909",
  null
  
)

export default component.exports